import { useNavigate } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import { Logo } from "@/components/Common";
import { useSeo } from "@/lib/seo";
import { useAuth } from "@/context/AuthContext";

export default function NotFound() {
  const navigate = useNavigate();
  const { user } = useAuth();
  useSeo({ title: "Page not found | Launch to Income", description: "The page you are looking for could not be found.", path: "/404", noindex: true });
  const home = () => navigate(user ? (user.role === "founder" ? "/founder" : "/dashboard") : "/");

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#FDFCFE] px-6 text-center" data-testid="not-found-page">
      <div className="mb-8"><Logo height="h-9" /></div>
      <span className="grid h-14 w-14 place-items-center rounded-2xl bg-brand-surface">
        <Compass size={26} className="text-brand" strokeWidth={1.8} />
      </span>
      <p className="mt-6 font-heading text-5xl font-bold tracking-tight text-brand-deep">404</p>
      <h1 className="mt-3 font-heading text-2xl font-semibold">This page took a wrong turn</h1>
      <p className="mt-2 max-w-md text-slate-600">
        The page you're looking for doesn't exist or has moved. Let's get you back to building your business.
      </p>
      <button
        data-testid="notfound-home-btn"
        onClick={home}
        className="mt-8 inline-flex items-center gap-2 rounded-lg bg-brand px-6 py-3 text-sm font-medium text-white transition-all duration-200 hover:bg-brand-hover hover:shadow-lift"
      >
        {user ? "Back to your workspace" : "Back to home"} <ArrowRight size={16} />
      </button>
    </div>
  );
}
